import React from "react";

function LoadingSpinner({ text = "", size = 6, color = "text-blue-600" }) {
  const sizeClass = `h-${size} w-${size}`;

  return (
    <div className="flex items-center justify-center gap-2 py-6">
      <svg
        className={`animate-spin ${sizeClass} ${color}`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
      {text && <span className={`text-sm ${color}`}>{text}</span>}
    </div>
  );
}

export default LoadingSpinner;
